import apiRequest from '@libs/apiRequest';
import { call, put } from 'redux-saga/effects';
import { fetchEmployeesForCreateLeaveSuccess, fetchEmployeesForCreateLeaveFailure } from 'leaveManagement/redux.actions';

export default function* () {
    try {
        const response = yield call(apiRequest, {
            url: '/employee/get/all/preview-role-based',
            method: 'GET',
            params: { limit: 500 }
        });

        const responseData = response.data || response;
        const employees = responseData.data || [];
        
        yield put(fetchEmployeesForCreateLeaveSuccess(Array.isArray(employees) ? employees : []));
    } catch (error) {
        yield put(fetchEmployeesForCreateLeaveFailure(error?.message || 'Failed to fetch employees'));
        yield put(fetchEmployeesForCreateLeaveSuccess([]));
        console.error('Failed to fetch employees for Create Leave:', error);
    }
}
